import { dAPI } from 'appSrc/api';

const requestVarInterests = () => ( {
    type: 'REQUEST_VARS_INTERESTS',
} );

const updateVars = ( newObj ) => ( {
    type: 'UPDATE_VARS',
    obj: newObj,
} );

const receiveVarInterests = ( interests ) => ( {
    type: 'RECEIVE_VARS_INTERESTS',
    interests,
} );

const retrieveVarInterests = function() {
    return dispatch => {
        dispatch( requestVarInterests() );
        return dAPI.get( '/interests' )
        .then( ( response ) => {
            var interests = response.data;
            interests.sort( ( a, b ) => {
                return a.interest.localeCompare( b.interest );
            } );
            dispatch( receiveVarInterests( interests ) );
            return interests;
        })
        .catch( () => {
            dispatch( receiveVarInterests( [] ) );
            return [];
        } );
    };
};

export {
    retrieveVarInterests,
    updateVars,
};
